import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import DokuParserJS from './docuparser'

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";


class WikiPageTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            content: null
        };
    }

    async componentDidMount(){
        const baseUrl = `${process.env.REACT_APP_API_HOST}/api/v2/`;

        const parser = new DokuParserJS({
            currentNamespace: 'wiki', // Current namespace for link resolution
            interwikiMap: {
                wp: 'https://en.wikipedia.org/wiki/',
                doku: 'https://www.dokuwiki.org/'
            },
            mediaBasePath: `${baseUrl}wiki_page/media/?path=`, // Base path for media files (local mode)
            pagesBasePath: '/data/pages/', // Base path for pages (local mode)
            useTxtExtension: true, // Append .txt to internal links
            useEmoji: true, // Use Unicode emojis (default: true)
            htmlok: true, // Enable HTML embedding
            typography: true, // Enable typography conversions
            toc: true // Generate TOC for >3 headings (default: false)
        });
        this.setState(
            {
                content: parser.parse(this.props.wikiPage.content)
            }
        )
    }

    render() {
        if (!this.state.content) {
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={1}
            >
                <div
                    dangerouslySetInnerHTML={{__html: this.state.content }}
                />
            </Stack>
        )
    }
}

export default WikiPageTab;
